import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdateBarComponent } from './update-bar.component';
import { SharedModule } from '../../shared.module';
import { MatButtonModule } from '@angular/material/button';


@NgModule({
	declarations: [
		UpdateBarComponent
	],
  imports: [
    CommonModule,
    SharedModule,
    MatButtonModule
  ],
	exports: [
		UpdateBarComponent
	]
})
export class UpdateBarModule {
}
